type Env = {
  readonly APLICACION_ID: string;
  readonly NOMBRE_APLICACION: string;
  readonly NOMBRE_SERVICIO_CONSUMIDOR: string;
  readonly TOKEN_SEGURIDAD: string;
  readonly TRANSACCION_ID: string;
  readonly USUARIO_CONSUMIDOR_ID: string;
  readonly OCP_APIM_SUBSCRIPTION_KEY: string;
  readonly CONTENT_TYPE: string;
  readonly BACKEND_URL: string;
  readonly MSAL_CLIENT_ID: string;
  readonly MSAL_AUTHORITY: string;
  readonly MSAL_GRAPH_ME_ENDPOINT: string;
  readonly MSAL_REFRESH_TOKEN: string;
  readonly MSAL_PRODUCT_SCOPE: string;
  readonly MSAL_REDIRECT_URI: string;
  readonly MSAL_LOGOUT_REDIRECT_URI: string;
  readonly MSAL_STORAGE: string;
};

const env: Env = {
  APLICACION_ID: String(import.meta.env.VITE_APLICACION_ID),
  NOMBRE_APLICACION: String(import.meta.env.VITE_NOMBRE_APLICACION),
  NOMBRE_SERVICIO_CONSUMIDOR: String(
    import.meta.env.VITE_NOMBRE_SERVICIO_CONSUMIDOR
  ),
  TOKEN_SEGURIDAD: String(import.meta.env.VITE_TOKEN_SEGURIDAD),
  TRANSACCION_ID: String(import.meta.env.VITE_TRANSACCION_ID),
  USUARIO_CONSUMIDOR_ID: String(import.meta.env.VITE_USUARIO_CONSUMIDOR_ID),
  OCP_APIM_SUBSCRIPTION_KEY: String(
    import.meta.env.VITE_OCP_APIM_SUBSCRIPTION_KEY
  ),
  CONTENT_TYPE: String(import.meta.env.VITE_CONTENT_TYPE),
  BACKEND_URL: String(import.meta.env.VITE_BACKEND_URL),
  MSAL_CLIENT_ID: String(import.meta.env.VITE_APP_MSAL_CLIENT_ID),
  MSAL_AUTHORITY: String(import.meta.env.VITE_APP_MSAL_AUTHORITY),
  MSAL_GRAPH_ME_ENDPOINT: String(
    import.meta.env.VITE_APP_MSAL_GRAPH_ME_ENDPOINT
  ),
  MSAL_REFRESH_TOKEN: String(import.meta.env.VITE_APP_MSAL_REFRESH_TOKEN),
  MSAL_PRODUCT_SCOPE: String(import.meta.env.VITE_APP_MSAL_PRODUCT_SCOPE),
  MSAL_REDIRECT_URI: String(import.meta.env.VITE_APP_MSAL_REDIRECT_URI),
  MSAL_LOGOUT_REDIRECT_URI: String(
    import.meta.env.VITE_APP_MSAL_LOGOUT_REDIRECT_URI
  ),
  MSAL_STORAGE: String(import.meta.env.VITE_APP_MSAL_STORAGE),
};

export default env;
